import { ButtonColors, ButtonHeight } from '~/components/ui/Button';
import { CloseButton } from '~/components/ui/CloseButton';
import { Divider } from '~/components/ui/Divider';
import { Text } from '~/components/ui/Text';
import { StyledContainer, StyledTopContainer } from './Head.styled';

const Head = () => {
	return (
		<StyledContainer>
			<StyledTopContainer>
				<Text style={{ fontSize: 18, fontWeight: 700, color: '#FFFFFF' }}>
					Подсказка
				</Text>
				<CloseButton
					height={ButtonHeight.Height30}
					color={ButtonColors.Default}
					iconSize={14}
					onClick={() => {}}
				/>
			</StyledTopContainer>
			<Divider $direction="H" />
		</StyledContainer>
	);
};

export { Head };
